module.exports = __webpack_public_path__ + "img/LL_logo.6166234a.png";